/* eslint-disable no-undef */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.jsx';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

// Enable this import for development logging
// import { store, persistor } from '../../redux/store.dev.js';
// Enable this import for production builds
import { store, persistor } from '../../redux/store.prod.js';

var react_app_wrapper = document.querySelector("#station-map__app-wrapper");

// Don't run on a non-React page
if (react_app_wrapper !== null) {
    ReactDOM.render(
      <Provider store={store}>
        <React.StrictMode>
          <div>
            <PersistGate persistor={persistor}>
              <App appConfig={stationMapConfiguration} />
            </PersistGate>
          </div>
        </React.StrictMode>
      </Provider>
    , react_app_wrapper);
}